import axios from 'axios'
import xpath from 'xpath'
import dom from 'xmldom'
import { rateSheetURL } from './config.js'

//process.env['NODE_TLS_REJECT_UNAUTHORIZED'] = 0

const round = num => +(Math.round(num + 'e+2') + 'e-2')

// accept axios request
// return object containing {mb,apy,dr} which each contain raw xpath nodes
const selectXpaths = res => {
  const data = new dom.DOMParser().parseFromString(res)

  return {
    mb: xpath.select(
      '//MONEYMARKETACCOUNTS//PRODUCT[text()="Preferred Money Market"]/../*[contains(name(),"MB")]',
      data,
    ),
    apy: xpath.select(
      '//MONEYMARKETACCOUNTS//PRODUCT[text()="Preferred Money Market"]/../*[contains(name(),"APY")]',
      data,
    ),
    dr: xpath.select(
      '//MONEYMARKETACCOUNTS//PRODUCT[text()="Preferred Money Market"]/../*[contains(name(),"DR")]',
      data,
    ),
  }
}

// accept object from selectXpaths
// return just the data we care about out of the xpath nodes
const grabRelevantData = nodes =>
  nodes.mb.map((mbNode, i) => ({
    mb: mbNode.firstChild.data
      //cleanup commas
      .replace(/,/g, '')
      // match numbers with or without periods
      .match(/\d{1,}\.?\d{1,}/g),
    apy: nodes.apy[i].firstChild.data,
    dr: nodes.dr[i].firstChild.data,
  }))

const getRates = async url =>
  axios
    .get(url)
    .then(res => res.data)
    .then(selectXpaths)
    .then(grabRelevantData)
    .catch(err => {
      console.error(err.message)
      return []
    })

const generateRateSheet = rawRateSheet => {
  const MIN = 0
  const MAX = 1
  return rawRateSheet.map((node, i) => {
    try {
      // utility variables
      const isFirst = i === 0
      const isLast = i === rawRateSheet.length - 1
      const prevNode = rawRateSheet[i - 1]

      // values to return

      const rate = Number((node.dr * 100).toFixed(2))

      // first min = 0. last min = current max. rest min prevmax + 0.01
      // if prevNode.mb[MAX] doesnt exist then grab the prevnode min
      // this usually means the prevnode was the first node
      const min = isFirst
        ? 0
        : isLast
          ? Number(node.mb[MIN])
          : Number(prevNode.mb[MAX] || prevNode.mb[MIN]) + 0.01

      // first max = min. otherwise max=max. if NaN max = undefined
      const max = Number(isFirst ? node.mb[MIN] : node.mb[MAX]) || undefined

      // TODO: explain this
      const maxDiv =
        round((Math.pow(1 + rate /100 / 12, 12) - 1) * (max - min)) || undefined

      //  first blendedRange = convert dec to percentage str
      const blendedRange = isFirst
//        ? (node.apy * 100).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0] + '%'
//        : node.apy
          ? (Math.round((node.apy * 100).toString().match(/^-?\d+(?:\.\d{0,6})?/)[0] * 100) /100).toFixed(2) + '%'
          : node.apy

      const splitAPY = isFirst
        ? [undefined, blendedRange.replace('%', '')]
        : node.apy.match(/\d{1,}\.\d{1,}/g)
      const minAPY = Number(splitAPY[0]) || undefined
      const maxAPY = Number(splitAPY[1])

      return {
        min,
        max,
        rate,
        blendedRange,
        maxDiv,
        minAPY,
        maxAPY,
      }
    } catch (err) {
      console.error(err.message)
      return {}
    }
  })
}
export const fetchRateSheet = (url = rateSheetURL) =>
  getRates(url).then(raw => generateRateSheet(raw))



// WEBPACK FOOTER //
// ./src/fetchRateSheet.js